export default {
  Title: 'Agent Report Card Dashboard',
  Subtitle: 'Teacher grades, failure categories, and teacher-quality signals',
  VsPrior: 'vs. Prior 7 days',
  Weekly: 'Weekly',
  Daily: 'Daily',
  AllGuides: 'All guides',
  GuideFilterLabel: 'Guide',
  LoadError: 'Unable to load agent report card metrics right now.',
  MissingRollups: 'No rollup for #{dates} — those days count as zero.',
  KeyMetricsSection: 'GRADES - PAST 7 DAYS VS. PRIOR 7 DAYS',
  KeyMetrics: {
    Marked: 'CASES MARKED',
    Passed: 'CASES PASSED',
    FailRate: 'FAIL RATE',
    Flagged: 'FLAGGED',
    AutoFails: 'AUTO-FAILS',
    Previous: 'Prev: #{count}',
  },
  FailureCategoriesSection: 'FAILURE CATEGORIES',
  FailureCategories: {
    Title: 'Failures by category',
    Subtitle: 'Current vs. previous period',
    Category: 'CATEGORY',
    Now: 'NOW',
    Prev: 'PREV.',
    Delta: '+/-',
    Empty: 'No failures in this period.',
  },
  TeacherQualitySection: 'TEACHER QUALITY SIGNALS',
  TeacherQuality: {
    HumanReviews: 'HUMAN REVIEWS',
    Disagreements: 'TEACHER-HUMAN DISAGREEMENTS',
    PassButIntervened: 'TEACHER PASS, HUMAN RESCUED',
    SkippedIntervention: 'HUMAN INTERVENTION',
  },
  TokenSpendSection: 'TOKEN SPEND',
  TokenSpend: {
    Title: 'Teacher token spend',
    Subtitle: 'Bedrock tokens for the current period, split by purpose — cache reads and writes bill at different rates than plain input',
    Source: 'SOURCE',
    Input: 'INPUT',
    CacheRead: 'CACHE READ',
    CacheWrite: 'CACHE WRITE',
    Output: 'OUTPUT',
    Sweep: 'Live marking sweep',
    Regression: 'Regression checks',
    Total: 'Total',
  },
};
